import React, { useMemo, useState } from 'react';

import { useForm } from 'react-hook-form';
import { ObjectSchema } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import {SetupUserFormContext, SetupUserFormState, setupUserFormStateDefault, setupUserSchemaDefault} from '@Forms/users/SetupUserFormContext';

export const SetupUserFormProvider: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const [schema, setSchema] = useState<ObjectSchema<Partial<SetupUserFormState>>>(
    setupUserSchemaDefault
  );
  const methods = useForm({
    defaultValues: setupUserFormStateDefault,
    resolver: yupResolver(schema),
  });
  const value = useMemo(() => ({ schema, setSchema, methods }), [schema, setSchema, methods]);

  return (
    <SetupUserFormContext.Provider value={value}>{children}</SetupUserFormContext.Provider>
  );
};
